module.exports = __webpack_public_path__ + "files/f0ce6778d82d8480e1e60e45b08f21e2.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-5.png
// module id = 1480
// module chunks = 60